import SocketController from './SocketController'
import connect from './connect'

export default connect(SocketController)



// WEBPACK FOOTER //
// ./src/components/SocketController/index.js